import { render, staticRenderFns } from "./HSCodeListAddNew.vue?vue&type=template&id=3180293a&scoped=true"
import script from "./HSCodeListAddNew.vue?vue&type=script&lang=js"
export * from "./HSCodeListAddNew.vue?vue&type=script&lang=js"
import style0 from "./HSCodeListAddNew.vue?vue&type=style&index=0&id=3180293a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3180293a",
  null
  
)

export default component.exports